import { Placement } from "./Placement";
import {
  BODY_SKINS,
  DIRECTION_RIGHT,
  PLACEMENT_TYPE_HERO,
} from "../helpers/consts";
import Sprite from "../components/object-graphics/Sprite";
import { TILES } from "../helpers/tiles";

export class HeroSpawnPlacement extends Placement {
  isOnlyType() {
    return true;
  }

  spawnPlacementOnStart() {
    return {
      x: this.x,
      y: this.y,
      type: PLACEMENT_TYPE_HERO,
      direction: DIRECTION_RIGHT,
      skin: BODY_SKINS.NORMAL,
    };
  }

  appearsOnScreen() {
    return this.level.isEditMode;
  }

  renderComponent() {
    return <Sprite frameCoord={TILES.HERO_SPAWN} />;
  }
}
